"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypesComunica = void 0;
/**
 * Algebra operations that are defined by Comunica for internal use, but are not part of the SPARQL spec.
 */
var TypesComunica;
(function (TypesComunica) {
    TypesComunica["NODES"] = "nodes";
    TypesComunica["DISTINCT_TERMS"] = "distinctterms";
})(TypesComunica || (exports.TypesComunica = TypesComunica = {}));
//# sourceMappingURL=TypesComunica.js.map